import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {
  ContractService,
  ContractEntry,
  GetContractEntriesRequest,
} from '@app/core/services/contract/contract.service'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '@app/core/services/generic-list.service'
import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

@Injectable()
export class ContractEntryListService extends GenericListService<ContractEntry> {
  domain: string
  id: number
  filter: SearchFilter

  constructor(
    private contractSvc: ContractService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<ContractEntry>> {
    // build the service request
    const svcRequest: GetContractEntriesRequest = {
      domain: this.domain,
      id: this.id,
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.contractSvc.getContractEntries(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<ContractEntry> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
